/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
const Swal = require('sweetalert2');
import 'sweetalert2/src/sweetalert2.scss';
import LogRocket from 'logrocket';
import * as Sentry from '@sentry/browser';
import {Integrations} from '@sentry/tracing';

window.publishRoute = function (id) {
    Swal.fire({
        title: 'Are you sure?',
        text: 'Do you wish to publish this route?',
        icon: 'warning',
        showCancelButton: true,
        // confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, publish it!',
    }).then((result) => {
        if (result.isConfirmed) {
            const url = '/routes/' + id + '/publish';
            window.axios.post(url).then(function (response) {
                console.log(response);
                Swal.fire(
                    'Route Published!',
                    'Your route has been published!',
                    'success',
                ).then(() => {
                        const table = window.LaravelDataTables['routes-table'] ?? false;
                        if (table) {
                            table.ajax.reload(null, false);
                        }
                    },
                );
            })
                .catch(function (error) {
                    console.log(error);
                    Swal.fire(
                        'Error!',
                        'Publish Error Try again later!',
                        'error',
                    );
                });
        }
    });
};

window.toggleStatus = function () {
    const url = '/routes/bulk-change-status';
    const data = window.selectedItems ?? [];
    if (data.length === 0) {
        Swal.fire(
            'Error!',
            'No routes selected!',
            'error',
        );
        return;
    }
    const table = window.LaravelDataTables['routes-table'] ?? false;
    //Block table while running
    if (table) {
        //Todo: Implement .block() function
        //table.block();
    }
    Swal.fire({
        title: 'Toggle Route Status',
        text: 'Choose whether to publish or unpublish the selected routes.',
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Publish',
        denyButtonText: 'Unpublish',
    }).then((result) => {
        if (!result.isConfirmed && !result.isDenied) {
            return;
        }
        const status = result.isConfirmed ? 1 : 0;
        const action = status === 1 ? 'published' : 'unpublished';
        //Use axios to post data to the url and then update the table after response
        window.axios.post(url, {'routes': data, 'status': status})
            .then(function (response) {
                console.log(response);
                Swal.fire(
                    'Status Changed!',
                    `Your routes have been ${action}!`,
                    'success'
                ).then(() => {
                        if (table) {
                            const selectAll = $('#select-all');
                            if (selectAll && selectAll.prop('checked')) {
                                selectAll.prop('checked', false);
                            }
                            table.ajax.reload(null, false);
                        }
                    }
                );
            }).catch(function (error) {
            console.log(error.toJSON());
            Swal.fire('Error!', 'Status Change Error Try again later!', 'error');
        });
    });
};

function initCheckboxHandlers() {
    const table = window.LaravelDataTables['routes-table'] ?? false;
    if (!table) {
        console.log('No table');
        return;
    }
    // Handle the select-all checkbox scoped to table cells
    table.on('change', 'thead input[type="checkbox"]', function () {
        const checked = $(this).is(':checked');
        $('input[type="checkbox"]', table.cells().nodes()).prop('checked', checked);
    });

    // Handle individual checkboxes in table cells / the actual event when they all change. we dont want to add the actual
    // table header select all to the checkboxes array though
    table.on('change', 'input[type="checkbox"]', function () {
        const selectedItems = [];
        const selectAll = $('#select-all');
        $('tbody input[type="checkbox"]').each(function () {
            const data = table.row($(this).closest('tr')).data();
            console.log(data);
            if ($(this).is(':checked')) {
                selectedItems.push(data.id);
            } else {
                const index = selectedItems.indexOf(data.id);
                if (index > -1) {
                    selectedItems.splice(index, 1);
                }
                //Little bit of a hack it only reaaaaly needs to run once but
                if (selectAll.is(':checked')) {
                    selectAll.prop('checked', false);
                }
            }
        });
        console.log(selectedItems);
        //sorry ill fix this later
        window.selectedItems = selectedItems;
    });
}

// Mix does this automaticall but it doesnt shut up my IDE unless I do too
document.addEventListener('DOMContentLoaded', function () {
    const userIdMeta = document.querySelector('meta[name="user_id"]').content;
    const userNameMeta = document.querySelector('meta[name="user_name"]');
    const userEmailMeta = document.querySelector('meta[name="user_email"]');
    const userCompanyMeta = document.querySelector('meta[name="user_company_id"]');
    const userRoleMeta = document.querySelector('meta[name="user_role"]');

    // Init Foundation
    // Setup Datepickers
    //Global datepicker
    window.$('input.datepicker').datepicker({
        dateFormat: 'yy-mm-dd',
    });
    // Init Logrocket
    LogRocket.init('snap360/steo');
    // This is an example script - don't forget to change it!
    if (userIdMeta !== 'guest') {
        LogRocket.identify(`${userIdMeta}`, {
            name: `${userNameMeta.content}`,
            email: `${userEmailMeta.content}`,
            company: `${userCompanyMeta.content}`,
            role: `${userRoleMeta.content}`,
            // Add your own custom user variables here, ie:
            roles: 'pro',
        });
    }
    Sentry.init({
        dsn: 'https://f1b8956db0624b9aa52761ed9de6d16c@o444173.ingest.sentry.io/6097951',
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.0,
    });
    LogRocket.getSessionURL((sessionURL) => {
        Sentry.configureScope((scope) => {
            scope.setExtra('sessionURL', sessionURL);
        });
    });
    window.$('a').tooltip();
    window.$('button').tooltip();
    window.$(document).foundation();
    console.log('done new init');

    document.addEventListener('click', function (event) {
        if (event.target) {
            const reminderButton = event?.target?.closest('.swal2-modal-opener') ?? null;
            if (typeof reminderButton !== 'undefined' && reminderButton !== null) {
                console.log('reminder trigger');

                const reminderData = {
                    routeID: reminderButton?.dataset?.routeid ?? null,
                    busCompanyID: reminderButton?.dataset?.companyid ?? null,
                    vehicleID: reminderButton?.dataset?.vehicleid ?? null,
                    driverID: reminderButton?.dataset?.driverid ?? null,
                    contactID: reminderButton?.dataset?.contactid ?? null,
                    reminderType: reminderButton?.dataset?.remindertype || 'route'
                };

                const customEvent = new CustomEvent('openReminderModal', {
                    bubbles: true,
                    detail: reminderData
                });
                document.dispatchEvent(customEvent);
            }
            const resetButtonElement = event?.target?.closest('.buttons-reset') ?? null;
            if (typeof resetButtonElement !== 'undefined' && resetButtonElement !== null) {
                console.log(resetButtonElement);
                // Sorry this is a hack and a half
                const currentYear = document.querySelector('meta[name="activeSchoolYear"]').content;
                const table = window.LaravelDataTables['routes-table'] ?? false;
                document.getElementById('year-filter').value = currentYear;
                document.getElementById('route-filter').value = '';
                document.getElementById('mileage-filter').value = '';
                document.getElementById('retired-deleted-filter').value = '';
                document.getElementById("custom-filter-box").value = '';
                //company and depot filter rest if they exist
                if (document.getElementById('company-filter')) {
                    document.getElementById('company-filter').value = '';
                }
                if (document.getElementById('depot-filter')) {
                    document.getElementById('depot-filter').value = '';
                }
                document.getElementById('vehicle-filter').value = '';
                document.getElementById('driver-filter').value = '';
                table.ajax.reload(null, false);
                return;
            }
            const reloadButtonElement = event?.target?.closest('.buttons-reload') ?? null;
            if (typeof reloadButtonElement !== 'undefined' && reloadButtonElement !== null) {
                console.log(reloadButtonElement);
                return;
            }
            const deleteButtonElement = event?.target?.closest('.delete-button') ?? null;
            if (typeof deleteButtonElement !== 'undefined' && deleteButtonElement !== null) {
                const routeID = deleteButtonElement.dataset.id;
                console.log(`Delete Route ${routeID}`);
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'You can still revert this later.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.axios.post(`/routes/${routeID}`, {_method: 'DELETE'})
                            .then(function (response) {
                                // handle success
                                console.log(response);
                                Swal.fire(
                                    'Deleted!',
                                    'Your route has been deleted.',
                                    'success',
                                ).then(function () {
                                    if (typeof window.LaravelDataTables !== 'undefined') {
                                        const table = window.LaravelDataTables['routes-table'] ?? false;
                                        if (table) {
                                            table.ajax.reload(null, false);
                                        }
                                    }
                                    //If we are on an edit page redirect back to the table index
                                    if (window.location.href.includes('edit')) {
                                        window.location.href = '/routes';
                                    }
                                });
                            });
                    }
                });
            }
            const restoreButtonElement = event?.target?.closest('.restore-button') ?? null;
            if (typeof restoreButtonElement !== 'undefined' && restoreButtonElement !== null) {
                const id = restoreButtonElement.dataset.id;
                if (id) {
                    window.axios.get(`/routes/restore/${id}`).then(function (response) {
                        console.log(response);
                        Swal.fire(
                            'Route Restored!',
                            'Your route has been restored!',
                            'success',
                        ).then(() => {
                                const table = window.LaravelDataTables['routes-table'] ?? false;
                                if (table) {
                                    table.ajax.reload(null, false);
                                }
                            },
                        );
                    }).catch(function (error) {
                        console.log(error);
                        Swal.fire(
                            'Restore Error!',
                            'Try again later!',
                            'error',
                        );
                    });
                }
            }
            // delete-button-vehicle
            const deleteButtonVehicleElement = event?.target?.closest('.delete-button-vehicle') ?? null;
            if (typeof deleteButtonVehicleElement !== 'undefined' && deleteButtonVehicleElement !== null) {
                const vehicleID = deleteButtonVehicleElement.dataset.id;
                console.log(`Delete Vehicle ${vehicleID}`);
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'You can revert this later.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.axios.post(`/vehicles/${vehicleID}`, {_method: 'DELETE'})
                            .then(function (response) {
                                // handle success
                                console.log(response);
                                Swal.fire(
                                    'Deleted!',
                                    'Your vehicle has been deleted.',
                                    'success',
                                ).then(function () {
                                    window.location.reload();
                                });
                            });
                    }
                });
            }
            // delete-button-vehicle
            const restoreButtonVehicleElement = event?.target?.closest('.restore-button-vehicle') ?? null;
            if (typeof restoreButtonVehicleElement !== 'undefined' && restoreButtonVehicleElement !== null) {
                const vehicleID = restoreButtonVehicleElement.dataset.id;
                console.log(`Restore Vehicle ${vehicleID}`);
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'Do you wish to restore this vehicle',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, restore it!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.axios.post(`/vehicles/${vehicleID}/restore`, {_method: 'PATCH'})
                            .then(function (response) {
                                // handle success
                                console.log(response);
                                Swal.fire(
                                    'Restored!',
                                    'Your vehicle has been restored.',
                                    'success',
                                ).then(function () {
                                    window.location.reload();
                                });
                            });
                    }
                });
            }
            //Clear route button
            const clearRouteButtonElement = event?.target?.closest('.clear-route') ?? null;
            if (typeof clearRouteButtonElement !== 'undefined' && clearRouteButtonElement !== null) {
                //read data id of button
                const dataID = clearRouteButtonElement.dataset.id;
                //Swal fire to confirm then delete
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'You can NOT revert this later.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Clear it!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        //axios get /routes/clear/id
                        window.axios.get(`/routes/clear/${dataID}`)
                            .then(function (response) {
                                if (response.status === 200 && response.data.success === true) {
                                    Swal.fire(
                                        'Cleared!',
                                        'Your route has been cleared.',
                                        'success',
                                    ).then(function () {
                                        if (typeof window.LaravelDataTables !== 'undefined') {
                                            const table = window.LaravelDataTables['routes-table'] ?? false;
                                            if (table) {
                                                table.ajax.reload(null, false);
                                            }
                                        }
                                        //If we are on an edit page redirect back to the table index
                                        if (window.location.href.includes('edit')) {
                                            window.location.href = '/routes';
                                        }
                                    });
                                } else {
                                    //error
                                    Swal.fire(
                                        'Error!',
                                        'Something went wrong.',
                                        'error',
                                    );
                                }
                            });
                    }
                });
            }
            // delete backup button
            const deleteBackupButtonElement = event?.target?.closest('.delete-backup') ?? null;
            if (typeof deleteBackupButtonElement !== 'undefined' && deleteBackupButtonElement !== null) {
                const dataID = deleteBackupButtonElement.dataset.link;
                //Swal fire to confirm then delete
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'You can NOT revert this later.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Delete it!',
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.axios.get(`${dataID}`)
                            .then(function (response) {
                                // handle success
                                console.log(response);
                                Swal.fire(
                                    'Deleted!',
                                    'Your backup has been deleted.',
                                    'success',
                                ).then(function () {
                                    window.location.reload();
                                });
                            });

                    }
                });
            }
            //Delete button for depots
            const deleteButtonDepotElement = event?.target?.closest('.depot-delete-alert') ?? null;
            if(deleteButtonDepotElement){
                console.log('case hit');
                //Swal 2 alert warning the delete is permanent
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'You can NOT revert this later.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Delete it!',
                }).then((result) => {
                    //if confirmed
                    if (result.isConfirmed) {
                        //submit the form the button is contained in
                        deleteButtonDepotElement.closest('form').submit();
                    }
                });
            }
        }
    }, false);
    document.addEventListener('openReminderModal', (e) => {
        console.log(e);
        const { routeID, busCompanyID, vehicleID, contactID, reminderType, driverID } = e.detail;

        // Determine what ID to use for fetching contacts and sending reminder
        const entityID = routeID || vehicleID || contactID;
        const companyID = busCompanyID;

        Swal.fire({
            title: `${reminderType?.charAt(0).toUpperCase() + reminderType?.slice(1) || 'Reminder'} Form`,
            html: `<label>Reminder Reason
               <select required name="reason" class="swal2-input" id="reason">
                  <option value="verifyInfo">Verify Info Provided</option>
                  <option value="updateInfo">Update Info</option>
                  <option value="verifyMileage">Verify Mileage Info</option>
                  <option value="other">Other</option>
               </select></label>
               <label>Reminder Recipient
               <select disabled required name="user" class="swal2-input" id="user">
                  <option value="" selected>Loading</option>
               </select></label>
               <label>Memo to Bus Company
                <textarea rows="10" id="message" class="" name="message" required placeholder="Type your message here"></textarea>
                </label>`,
            confirmButtonText: 'Send Reminder',
            focusConfirm: false,
            didOpen: () => {
                console.log('fetching users');
                window.axios.get(`/contacts/${companyID}/data/`)
                    .then(function (response) {
                        console.log(response);
                        const contacts = response.data.contacts;
                        const optionValues = contacts.map((o) => `<option value="${o.id}">${o.name}</option>`);
                        const contactSelect = Swal.getPopup().querySelector('#user');
                        contactSelect.innerHTML = optionValues;
                        contactSelect.disabled = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        Swal.showValidationMessage('Error fetching users, please try again');
                    });
            },
            preConfirm: () => {
                const reason = Swal.getPopup().querySelector('#reason').value;
                const user = Swal.getPopup().querySelector('#user').value;
                const message = Swal.getPopup().querySelector('#message').value;
                if (!reason || !user || !message) {
                    Swal.showValidationMessage('Please select a reason, a user and enter a message');
                }
                return {reason, user, message};
            },
        }).then((result) => {
            // Check if user cancelled or dismissed the modal
            if (result.dismiss || !result.value) {
                console.log('User cancelled reminder');
                return; // Exit early if cancelled
            }

            const { reason, user, message } = result.value;

            // Build the payload based on reminder type
            const payload = {
                reason,
                message,
                userID: user,
                reminderType: reminderType || 'route'
            };

            // Add the appropriate ID based on type
            if (routeID){
                payload.routeID = routeID;
            }
            if (vehicleID){
                payload.vehicleID = vehicleID;
            }
            if (contactID){
                payload.contactID = contactID;
            }
            if (driverID){
                payload.driverID = driverID;
            }

            window.axios.post('/sendreminder', payload)
                .then(function (response) {
                    console.log(response);
                    Swal.fire(
                        'Reminder Sent!',
                        'Your message has been sent!',
                        'success',
                    );
                })
                .catch(function (error) {
                    console.log(error);
                    Swal.fire(
                        'Mail Error!',
                        'Try again later!',
                        'error',
                    );
                });
        }).catch((error) => {
            // Handle any other errors
            console.log('SweetAlert error:', error);
        });
    }, false);
    //call old setups
    oldStartup();
}, false);

//Listen for tableInitComplete
document.addEventListener('tableInitComplete', (e) => {
    console.log(e);
    initCheckboxHandlers();
});

//Event listener for backup trigger
document.addEventListener('backupTrigger', () => {
    //Fire a swal modal
    Swal.fire({
        title: 'Backup Database',
        html: `<p>Are you sure you want to backup the database?</p>
                <p>This will take a few minutes and the site will be slow during this time.</p>
                <p>You will recieve a notification when complete</p>
                <p>Do you wish to continue?</p>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, backup now!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true,
    }).then((result) => {
        if (result.isConfirmed) {
            //fire a post request to /admin/create-backup, dont wait for a response
            window.axios.post('/admin/create-backup').then((response) => {
                //if 200 status code and stuatus = sucess
                if (response.status === 200 && response.data.status === 'success') {
                    Swal.fire(
                        'Backup Started!',
                        'Your backup has started, you will recieve a notification when complete.',
                        'success',
                    );
                }
            });


        }
    });
});
//Add a click listenr to the backup button if it exists
const backupButton = document.querySelector('#backup-button');
if (backupButton) {
    backupButton.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('backupTrigger'));
    });
}
//Add a listener to the datatables page change event to toggle off the select all
document.addEventListener('drawCallbackEvent', () => {
    console.log('draw callback fired');
    // A redraw replaces the visible route rows, so any IDs collected from the
    // previous page/filter are no longer a valid selection.
    window.selectedItems = [];
    const selectAll = document.querySelector('#select-all');
    if (selectAll && selectAll.checked) {
        selectAll.checked = false;
    }
});

//OLD WEIRD FILE PORT
function oldStartup(){
    // Vehicle age calculation
    if ($('#vehicle_manufactured_year').length) {
        const madeyear = $("#vehicle_manufactured_year").val();
        const year = new Date().getFullYear();
        const age = parseInt(year) - parseInt(madeyear);
        $("#vehicle_age").val(age);
    }

// Sticky header
    if ($('.header').length && !$('.nostickheader').length) {
        const stickyNavTop = $('.header').offset().top + 10;

        const stickyNav = () => {
            const scrollTop = $(window).scrollTop();
            $('.header').toggleClass('sticky', scrollTop > stickyNavTop);
        };

        stickyNav();
        $(window).scroll(stickyNav);
    }

// Anchor scrolling
    $('.anchorIt').click(function () {
        const offset = $('.header').hasClass('sticky') ? 105 : 199;
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - offset
        }, 1000);
        return false;
    });

// Input masking
    $('.cvor').mask('000-000-000', { placeholder: "000-000-000" });
    $('.phone').mask('(000) 000-0000', { placeholder: "(000) 000-0000" });
    $('.postal').mask('A0A 0A0', { placeholder: "S0S 0S0" });
    $('.date').mask('0000-00-00', { placeholder: "YYYY-MM-DD" });
    $('.money2').mask("#", { reverse: true });
    $('.stNumber').mask('ST000', { placeholder: "ST000" });
    $('.stNumber').on("keypress keyup blur", function () {
        $(this).val($(this).val().replace(/^.{2}/, 'ST'));
    });
    $('.numeric').on("keypress keyup blur", function (event) {
        $(this).val($(this).val().replace(/[^\d].+/, ""));
        if (event.which < 48 || event.which > 57)
        {
            event.preventDefault();
        }
    });
    $('.integer').on("keypress keyup blur", function () {
        const value = parseInt($(this).val()) || '';
        $(this).val(value);
    });
    $('#route_number').mask('0000S', { placeholder: "0000A" });
    $('.license_number').mask('S0000-00000-00000', { placeholder: "A0000-00000-00000" });

// Prevent double submission
    $('form').preventDoubleSubmission();

// Accordion toggle icon
    const toggleIcon = () => console.log("toggle icon called");
    if ($(".accordion-title").length){
        $(".accordion-title").on('click', toggleIcon);
        $('.accordion-content').on('up.zf.accordion down.zf.accordion', toggleIcon);
    }
}
